export default __webpack_public_path__ + "static/media/webpack.5a9d1127.svg";